import { SceneLinkHotspot } from '../hotspots/sceneLink/SceneLinkHotspot';
import * as bundleApi from '@ael/virtual-tour-icon-bundle-api';
export function convertTourSceneLinkDto(sceneLinkDto, iconBundle, assetsUrls) {
    const params = {
        position: {
            sceneCoordinates: {
                x: sceneLinkDto.position.xAxis,
                y: sceneLinkDto.position.yAxis,
            },
            virtualTourScene: {
                sceneGuid: sceneLinkDto.tourSceneOriginGuid,
                sceneIndex: sceneLinkDto.position.sceneIndex,
            },
        },
        destinationTourSceneGuid: sceneLinkDto.tourSceneDestinationGuid,
        hasTilt: sceneLinkDto.hasTilt,
    };
    const hotspot = new SceneLinkHotspot(params, iconBundle, assetsUrls);
    const linkIconIdentifier = sceneLinkDto.icon.identifier;
    const iconId = linkIconIdentifier && bundleApi.isVirtualTourIconId(linkIconIdentifier, iconBundle) ? linkIconIdentifier : 'up';
    hotspot.updateIcon(iconId, params.hasTilt);
    if (sceneLinkDto.destinationLabel) {
        hotspot.updateDestinationLabel(sceneLinkDto.destinationLabel);
    }
    return hotspot;
}
